import ProdutoSimuladorService from "@/services/ProdutoSimuladorService";

export const produtoSimulador = {
  namespaced: true,
  state: {
    produtoSimulador: {},
  },
  actions: {
    getProdutoSimulador({ commit }, payload) {
      return ProdutoSimuladorService.GetProdutoSimulador(payload).then(
        (produtoSimulador) => {
          return Promise.resolve(produtoSimulador);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postProdutoSimulador({ commit }, payload) {
      return ProdutoSimuladorService.PostProdutoSimulador(payload).then(
        (produtoSimulador) => {
          return Promise.resolve(produtoSimulador);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putProdutoSimulador({ commit }, payload) {
      return ProdutoSimuladorService.PutProdutoSimulador(payload).then(
        (produtoSimulador) => {
          return Promise.resolve(produtoSimulador);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteProdutoSimulador({ commit }, payload) {
      return ProdutoSimuladorService.DeleteProdutoSimulador(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getProdutoSimuladorOData({ commit }, payload) {
      return ProdutoSimuladorService.GetProdutoSimuladorOData(payload).then(
        (produtoSimulador) => {
          return Promise.resolve(produtoSimulador);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default produtoSimulador;
